import { dataNeutralFaceSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconNeutralFaceSolid = /*#__PURE__*/createIcon(dataNeutralFaceSolid)
export default IconNeutralFaceSolid
